import React, { FC } from 'react';
import { ApprovalPageStatsProps } from './ApprovalPageStatsProps';
import { Stack } from '@mui/material';
import StatsCard from '../StatsCard';
import { getIdFromLabel } from '../../utils/utils';

const ApprovalPageStats: FC<ApprovalPageStatsProps> = ({ stats, loading }) => {
  return (
    <Stack direction={'row'} spacing={1} flex={4}>
      {stats.map((stat) => (
        <StatsCard
          key={getIdFromLabel(stat.label)}
          {...stat}
          loading={loading}
        />
      ))}
    </Stack>
  );
};

export default ApprovalPageStats;
